<template>
  <div>
    <SearchWithButton :search-text.sync="searchText">
      <template v-slot:search-button>
        <v-btn
          @click="confirmSearch"
          :disabled="!filterHasChanged"
          class="ml-2"
          fab
          small
          icon
        >
          <v-icon>mdi-search-web</v-icon>
        </v-btn>
        <v-btn @click="toggleFilters" class="ml-2" fab small icon>
          <v-badge
            bordered
            :dot="!viewFiltersNumber"
            :value="filtersActive"
            :content="filtersNumber"
          >
            <v-icon>mdi-filter</v-icon>
          </v-badge>
        </v-btn>
      </template>
    </SearchWithButton>

    <v-banner
      transition="slide-y-transition"
      v-model="showFilter"
      class="filter-container"
    >
      <div class="d-flex flex-wrap">
        <template v-for="filter in localFilters">
          <FilterBoolean
            :labelFilter="filter.text"
            v-model="filter.value"
            class="px-3"
            :key="filter.name"
            v-if="filter.type == 'Boolean'"
            @change="handleFilterChange($event, filter.name)"
          />
          <FilterDate
            v-model="filter.value"
            class="py-3"
            :key="filter.name"
            v-if="filter.type == 'Date'"
            @change="handleFilterChange($event, filter.name)"
          />
        </template>
      </div>

      <div class="d-flex justify-end">
        <v-btn
          text
          color="primary"
          class="my-1 mr-2"
          :disabled="!filterHasChanged"
          @click="confirmSearch"
        >
          Search
        </v-btn>
      </div>
    </v-banner>
  </div>
</template>

<script>
import emittable from "../../mixins/emittable";
import SearchWithButton from "../searchWithButton";
import FilterBoolean from "../filterable/filterBoolean";
import FilterDate from "../filterable/filterDate";

import {
  VBtn,
  VIcon,
  VBadge,
  VBanner,
} from 'vuetify/lib'

export default {
  name: "SearchWithFilter",
  mixins: [emittable],
  components: {
    SearchWithButton,
    FilterBoolean,
    FilterDate,
    VBtn,
    VIcon,
    VBadge,
    VBanner
  },
  props: {
    filters: {
      type: Array,
      default: function () {
        return [];
      },
    },
    viewFiltersNumber: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      searchText: undefined,
      filtersNumber: 0,
      filtersActive: false,
      activeFilters: {},
      localFilters: [...this.filters],
      showFilter: false,
      filterHasChanged: false,
    };
  },
  methods: {
    toggleFilters() {
      this.showFilter = !this.showFilter;
    },
    handleFilterChange(newVal, filterName) {
      console.log(filterName);
      this.recalculateActiveFilters();
    },
    recalculateActiveFilters() {
      this.filtersNumber = 0;
      this.filtersActive = false;
      this.filterHasChanged = true;

      if (!this.searchText) this.activeFilters["searchText"] = null;
      else {
        this.activeFilters["searchText"] = this.searchText;
      }

      for (let i = 0; i < this.localFilters.length; i++) {
        if (
          (this.localFilters[i].type == "Boolean" ||
            this.localFilters[i].type == "Date") &&
          this.localFilters[i].value
        ) {
          this.activeFilters[this.localFilters[i].name] = this.localFilters[
            i
          ].value;
          this.filtersNumber++;
          this.filtersActive = true;
        } else if (!this.localFilters[i].value) {
          this.activeFilters[this.localFilters[i].name] = null;
        }
      }
    },
    confirmSearch() {
      this.filterHasChanged = false;
      this.emit("confirm", this.activeFilters);
    },
  },
  watch: {
    searchText() {
      this.recalculateActiveFilters();
    },
  },
};
</script>

<style  >
.filter-container .v-banner__wrapper {
  padding: 0px !important;
}
</style>